module.exports = __webpack_public_path__ + "static/drag_1-67f27d371cf2c3303777b2954dad3ec0.svg";